import React from 'react';

export default class General extends React.Component {
    static weeklyMessageStart = "Social Interest Increased by";
    static weeklyMessageEnd = "Last Week";
    static spadmin="d53g806b2af4633e64asf88ds33fbe416ds5a06a";
  }

 